/* ============
 * Main File
 * ============
 *
 * Will initialize the application.
 */

import Vue from 'vue'
import { AdminRouter, AdminStore, AuthMixin } from 'stylemix-vue-admin'
import App from './App'

/* ============
 * Styling
 * ============
 *
 * Import the application styling.
 */
import './assets/scss/tailwind.scss'
import './assets/scss/app.scss'

/* ============
 * Plugins
 * ============
 */
import './plugins/admin'
import './plugins/base'
import { messageGroups } from './plugins/i18n'
import './plugins/thumbnail'

import './zones'
import InitDivision from './zones/InitDivision'
import './gate/module'
import GateMixin from './gate/GateMixin'
import AppConfig from './settings/AppConfig'
import { FETCH_SECTIONS } from './settings/store'
import adminMenuStore from './admin-menu/store'

if (typeof window !== 'undefined') window.__MENU_TYPE__ = 'console'
import { FETCH_MENU } from './admin-menu/store'
import LanguageMixin from './language-switcher/LanguageMixin'

AdminStore.registerModule('adminMenu', adminMenuStore)

// required for widget
window.Vue = Vue

// Include translations for vendor packages
messageGroups.push('vendor')

/**
 * Concord Modules system
 * Scan for module.js file in each Concord module
 */
try {
  const concordModules = require.context('../../app/Modules', true, /[Cc]onsole\/src\/module\.js$/)
  concordModules.keys().forEach(module => {
    concordModules(module)
  })
} catch (e) {
  /* eslint-disable-next-line no-console */
  console.log('No Concord modules with Vue components found')
}

/**
 * Module system
 * Scan for module.js file in each first level directories
 */
const modules = require.context('.', true, /module\.js/)
modules.keys().forEach(module => {
  modules(module)
})

/* ============
 * Main App
 * ============
 *
 * Last but not least, we import the main application.
 */

const env = process.env
Vue.config.devtools = env.VUE_APP_DEVTOOLS || env.NODE_ENV !== 'production'
Vue.config.ignoredElements = ['at-widget-booking']

/* eslint-disable no-new */
new Vue({
  /**
   * Bind the Vue instance to the HTML.
   */
  el: '#app',

  /**
   * The router.
   */
  router: AdminRouter,

  /**
   * The Vuex store.
   */
  store: AdminStore,

  mixins: [AppConfig, AuthMixin, GateMixin, InitDivision, LanguageMixin],

  data: () => ({
    ready: false,
  }),

  beforeCreate() {
    this.$on('account-loaded', () => {
      if (this.$allows('administer')) {
        AdminStore.dispatch(`settings/${FETCH_SECTIONS}`)
      }
      if (process.env.VUE_APP_USE_API_MENU === 'true') {
        AdminStore.dispatch(`adminMenu/${FETCH_MENU}`).catch(() => {
          /* fallback to static menu on error */
        })
      }
    })
  },

  created() {
    this.onResizeEvent()
    window.addEventListener('resize', this.onResizeEvent)
  },

  methods: {
    setReady() {
      this.ready = true
      document.getElementById('page-loader').style.display = 'none'
    },
    onResizeEvent() {
      // hide sidebar if window width less than 1400
      const body = document.body
      screen.width < 1400
        ? body.classList.add('sidebar-xs')
        : body.classList.remove('sidebar-xs')
    },
  },
  /**
   * Will render the application.
   *
   * @param {Function} h Will create an element.
   */
  render(h) {
    return this.ready ? h(App) : null
  },
})
